import { FrictionDataType } from "../../interface/dataTypeInterface";

// https://www.emachineshop.com/coefficient-of-friction/
export const frictionData: FrictionDataType[] = [
  {
    name: "Friction Coefficients",
    id: "frictioncoefficients",
    descriptions: [""],
    updatedAt: "2022-08-20",
    data: [
      {
        friction_material_1: { value: "Aluminum" },
        friction_material_2: { value: "Aluminum" },
        conditions: { value: "Clean and Dry" },
        friction_coefficient_static: { value: "1.05 - 1.35" },
        friction_coefficient_dynamic: { value: "1.4" },
      },

      {
        friction_material_1: { value: "Aluminum" },
        friction_material_2: { value: "Aluminum" },
        conditions: { value: "Lubricated and Greasy" },
        friction_coefficient_static: { value: "0.3" },
        friction_coefficient_dynamic: { value: "" },
      },

      {
        friction_material_1: { value: "Aluminum-bronze" },
        friction_material_2: { value: "Steel" },
        conditions: { value: "Clean and Dry" },
        friction_coefficient_static: { value: "0.45" },
        friction_coefficient_dynamic: { value: "" },
      },

      {
        friction_material_1: { value: "Aluminum" },
        friction_material_2: { value: "Mild Steel" },
        conditions: { value: "Clean and Dry" },
        friction_coefficient_static: { value: "0.61" },
        friction_coefficient_dynamic: { value: "0.47" },
      },

      {
        friction_material_1: { value: "Aluminum" },
        friction_material_2: { value: "Snow" },
        conditions: { value: "Wet 0\u00B0C" },
        friction_coefficient_static: { value: "0.4" },
        friction_coefficient_dynamic: { value: "" },
      },

      {
        friction_material_1: { value: "Aluminum" },
        friction_material_2: { value: "Snow" },
        conditions: { value: "Dry 0\u00B0C" },
        friction_coefficient_static: { value: "0.35" },
        friction_coefficient_dynamic: { value: "" },
      },

      {
        friction_material_1: { value: "Brake material" },
        friction_material_2: { value: "Cast iron" },
        conditions: { value: "Clean and Dry" },
        friction_coefficient_static: { value: "0.4" },
        friction_coefficient_dynamic: { value: "" },
      },
      {
        friction_material_1: { value: "Brake material" },
        friction_material_2: { value: "Cast iron (wet)" },
        conditions: { value: "Clean and wet" },
        friction_coefficient_static: { value: "0.2" },
        friction_coefficient_dynamic: { value: "" },
      },

      {
        friction_material_1: { value: "Brass" },
        friction_material_2: { value: "Steel" },
        conditions: { value: "Clean and dry" },
        friction_coefficient_static: { value: "0.51" },
        friction_coefficient_dynamic: { value: "0.44" },
      },

      {
        friction_material_1: { value: "Brass" },
        friction_material_2: { value: "Steel" },
        conditions: { value: "Lubricated and Greasy" },
        friction_coefficient_static: { value: "0.19" },
        friction_coefficient_dynamic: { value: "" },
      },

      {
        friction_material_1: { value: "Brass" },
        friction_material_2: { value: "Steel" },
        conditions: { value: "Castor oil" },
        friction_coefficient_static: { value: "0.11" },
        friction_coefficient_dynamic: { value: "" },
      },

      {
        friction_material_1: { value: "Brass" },
        friction_material_2: { value: "Cast Iron" },
        conditions: { value: "Clean and Dry" },
        friction_coefficient_static: { value: "" },
        friction_coefficient_dynamic: { value: "0.3" },
      },

      {
        friction_material_1: { value: "Brass" },
        friction_material_2: { value: "Ice" },
        conditions: { value: "Clean 0\u00B0C" },
        friction_coefficient_static: { value: "" },
        friction_coefficient_dynamic: { value: "0.02" },
      },

      {
        friction_material_1: { value: "Brass" },
        friction_material_2: { value: "Ice" },
        conditions: { value: "Clean -80\u00B0C" },
        friction_coefficient_static: { value: "" },
        friction_coefficient_dynamic: { value: "0.15" },
      },

      {
        friction_material_1: { value: "Brick" },
        friction_material_2: { value: "Wood" },
        conditions: { value: "Clean and Dry" },
        friction_coefficient_static: { value: "0.6" },
        friction_coefficient_dynamic: { value: "" },
      },

      {
        friction_material_1: { value: "Bronze" },
        friction_material_2: { value: "Steel" },
        conditions: { value: "Lubricated and Greasy" },
        friction_coefficient_static: { value: "0.16" },
        friction_coefficient_dynamic: { value: "" },
      },

      {
        friction_material_1: { value: "Bronze" },
        friction_material_2: { value: "Cast Iron" },
        conditions: { value: "Clean and Dry" },
        friction_coefficient_static: { value: "" },
        friction_coefficient_dynamic: { value: "0.22" },
      },

      {
        friction_material_1: { value: "Bronze - sintered" },
        friction_material_2: { value: "Steel" },
        conditions: { value: "Lubricated and Greasy" },
        friction_coefficient_static: { value: "0.13" },
        friction_coefficient_dynamic: { value: "" },
      },

      {
        friction_material_1: { value: "Cadmium" },
        friction_material_2: { value: "Cadmium" },
        conditions: { value: "Clean and Dry" },
        friction_coefficient_static: { value: "0.5" },
        friction_coefficient_dynamic: { value: "" },
      },

      {
        friction_material_1: { value: "Cadmium" },
        friction_material_2: { value: "Cadmium" },
        conditions: { value: "Lubricated and Greasy" },
        friction_coefficient_static: { value: "0.05" },
        friction_coefficient_dynamic: { value: "" },
      },

      {
        friction_material_1: { value: "Cadmium" },
        friction_material_2: { value: "Chromium" },
        conditions: { value: "Clean and Dry" },
        friction_coefficient_static: { value: "0.41" },
        friction_coefficient_dynamic: { value: "" },
      },

      {
        friction_material_1: { value: "Cadmium" },
        friction_material_2: { value: "Chromium" },
        conditions: { value: "Lubricated and Greasy" },
        friction_coefficient_static: { value: "0.34" },
        friction_coefficient_dynamic: { value: "" },
      },

      {
        friction_material_1: { value: "Cadmium" },
        friction_material_2: { value: "Mild Steel" },
        conditions: { value: "Clean and Dry" },
        friction_coefficient_static: { value: "" },
        friction_coefficient_dynamic: { value: "0.46" },
      },

      {
        friction_material_1: { value: "Cast Iron" },
        friction_material_2: { value: "Cast Iron" },
        conditions: { value: "Clean and Dry" },
        friction_coefficient_static: { value: "1.1 " },
        friction_coefficient_dynamic: { value: "0.15" },
      },

      {
        friction_material_1: { value: "Cast Iron" },
        friction_material_2: { value: "Cast Iron" },
        conditions: { value: "Clean and Dry" },
        friction_coefficient_static: { value: "" },
        friction_coefficient_dynamic: { value: "0.15" },
      },

      {
        friction_material_1: { value: "Cast Iron" },
        friction_material_2: { value: "Cast Iron" },
        conditions: { value: "Lubricated and Greasy" },
        friction_coefficient_static: { value: "" },
        friction_coefficient_dynamic: { value: "0.07" },
      },

      {
        friction_material_1: { value: "Cast Iron" },
        friction_material_2: { value: "Oak" },
        conditions: { value: "Clean and Dry" },
        friction_coefficient_static: { value: "" },
        friction_coefficient_dynamic: { value: "0.49" },
      },

      {
        friction_material_1: { value: "Cast Iron" },
        friction_material_2: { value: "Oak" },
        conditions: { value: "Lubricated and Greasy" },
        friction_coefficient_static: { value: "" },
        friction_coefficient_dynamic: { value: "0.075" },
      },

      {
        friction_material_1: { value: "Cast iron" },
        friction_material_2: { value: "Mild Steel" },
        conditions: { value: "Clean and Dry" },
        friction_coefficient_static: { value: "0.4" },
        friction_coefficient_dynamic: { value: "" },
      },

      {
        friction_material_1: { value: "Cast iron" },
        friction_material_2: { value: "Mild Steel" },
        conditions: { value: "Clean and Dry" },
        friction_coefficient_static: { value: "" },
        friction_coefficient_dynamic: { value: "0.23" },
      },

      {
        friction_material_1: { value: "Cast iron" },
        friction_material_2: { value: "Mild Steel" },
        conditions: { value: "Lubricated and Greasy" },
        friction_coefficient_static: { value: "0.21" },
        friction_coefficient_dynamic: { value: "0.133" },
      },

      {
        friction_material_1: { value: "Car tire" },
        friction_material_2: { value: "Asphalt" },
        conditions: { value: "Clean and Dry" },
        friction_coefficient_static: { value: "0.72" },
        friction_coefficient_dynamic: { value: "" },
      },

      {
        friction_material_1: { value: "Car tire" },
        friction_material_2: { value: "Grass" },
        conditions: { value: "Clean and Dry" },
        friction_coefficient_static: { value: "0.35 " },
        friction_coefficient_dynamic: { value: "" },
      },

      {
        friction_material_1: { value: "Carbon (hard)" },
        friction_material_2: { value: "Carbon" },
        conditions: { value: "Clean and Dry" },
        friction_coefficient_static: { value: "0.16" },
        friction_coefficient_dynamic: { value: "" },
      },

      {
        friction_material_1: { value: "Carbon (hard)" },
        friction_material_2: { value: "Carbon" },
        conditions: { value: "Lubricated and Greasy" },
        friction_coefficient_static: { value: "0.12 - 0.14" },
        friction_coefficient_dynamic: { value: "" },
      },

      {
        friction_material_1: { value: "Carbon" },
        friction_material_2: { value: "Steel" },
        conditions: { value: "Clean and Dry" },
        friction_coefficient_static: { value: "0.14" },
        friction_coefficient_dynamic: { value: "" },
      },

      {
        friction_material_1: { value: "Carbon" },
        friction_material_2: { value: "Steel" },
        conditions: { value: "Lubricated and Greasy" },
        friction_coefficient_static: { value: "0.11 - 0.14" },
        friction_coefficient_dynamic: { value: "" },
      },

      {
        friction_material_1: { value: "Chromium" },
        friction_material_2: { value: "Chromium" },
        conditions: { value: "Clean and Dry" },
        friction_coefficient_static: { value: "0.41" },
        friction_coefficient_dynamic: { value: "" },
      },

      {
        friction_material_1: { value: "Chromium" },
        friction_material_2: { value: "Chromium" },
        conditions: { value: "Lubricated and Greasy" },
        friction_coefficient_static: { value: "0.34" },
        friction_coefficient_dynamic: { value: "" },
      },

      {
        friction_material_1: { value: "Copper-Lead alloy" },
        friction_material_2: { value: "steel" },
        conditions: { value: "Clean and Dry" },
        friction_coefficient_static: { value: "0.22" },
        friction_coefficient_dynamic: { value: "" },
      },

      {
        friction_material_1: { value: "Copper" },
        friction_material_2: { value: "Copper" },
        conditions: { value: "Clean and Dry" },
        friction_coefficient_static: { value: "1.6" },
        friction_coefficient_dynamic: { value: "" },
      },

      {
        friction_material_1: { value: "Copper" },
        friction_material_2: { value: "Copper" },
        conditions: { value: "Lubricated and Greasy" },
        friction_coefficient_static: { value: "0.08" },
        friction_coefficient_dynamic: { value: "" },
      },

      {
        friction_material_1: { value: "Copper" },
        friction_material_2: { value: "Cast Iron" },
        conditions: { value: "Clean and Dry" },
        friction_coefficient_static: { value: "1.05" },
        friction_coefficient_dynamic: { value: "0.29" },
      },

      {
        friction_material_1: { value: "Copper" },
        friction_material_2: { value: "Mild Steel" },
        conditions: { value: "Clean and Dry" },
        friction_coefficient_static: { value: "0.53" },
        friction_coefficient_dynamic: { value: "0.36" },
      },

      {
        friction_material_1: { value: "Copper" },
        friction_material_2: { value: "Mild Steel" },
        conditions: { value: "Lubricated and Greasy" },
        friction_coefficient_static: { value: "" },
        friction_coefficient_dynamic: { value: "0.18" },
      },

      {
        friction_material_1: { value: "Copper" },
        friction_material_2: { value: "Mild Steel" },
        conditions: { value: "Oleic acid" },
        friction_coefficient_static: { value: "" },
        friction_coefficient_dynamic: { value: "0.18" },
      },

      {
        friction_material_1: { value: "Copper" },
        friction_material_2: { value: "Glass" },
        conditions: { value: "Clean and Dry" },
        friction_coefficient_static: { value: "0.68" },
        friction_coefficient_dynamic: { value: "0.53" },
      },

      {
        friction_material_1: { value: "Cotton" },
        friction_material_2: { value: "Cotton" },
        conditions: { value: "Threads" },
        friction_coefficient_static: { value: "0.3" },
        friction_coefficient_dynamic: { value: "" },
      },

      {
        friction_material_1: { value: "Diamond" },
        friction_material_2: { value: "Diamond" },
        conditions: { value: "Clean and Dry" },
        friction_coefficient_static: { value: "0.1" },
        friction_coefficient_dynamic: { value: "" },
      },

      {
        friction_material_1: { value: "Diamond" },
        friction_material_2: { value: "Diamond" },
        conditions: { value: "Lubricated and Greasy" },
        friction_coefficient_static: { value: "0.05 - 0.1" },
        friction_coefficient_dynamic: { value: "" },
      },

      {
        friction_material_1: { value: "Diamond" },
        friction_material_2: { value: "Metals" },
        conditions: { value: "Clean and Dry" },
        friction_coefficient_static: { value: "0.1 - 0.15" },
        friction_coefficient_dynamic: { value: "" },
      },

      {
        friction_material_1: { value: "Diamond" },
        friction_material_2: { value: "Metal" },
        conditions: { value: "Lubricated and Greasy" },
        friction_coefficient_static: { value: "0.1" },
        friction_coefficient_dynamic: { value: "" },
      },

      {
        friction_material_1: { value: "Garnet" },
        friction_material_2: { value: "Steel" },
        conditions: { value: "Clean and Dry" },
        friction_coefficient_static: { value: "" },
        friction_coefficient_dynamic: { value: "0.39" },
      },

      {
        friction_material_1: { value: "Glass" },
        friction_material_2: { value: "Glass" },
        conditions: { value: "Clean and Dry" },
        friction_coefficient_static: { value: "0.9 - 1.0" },
        friction_coefficient_dynamic: { value: "0.4" },
      },

      {
        friction_material_1: { value: "Glass" },
        friction_material_2: { value: "Glass" },
        conditions: { value: "Lubricated and Greasy" },
        friction_coefficient_static: { value: "0.1 - 0.6" },
        friction_coefficient_dynamic: { value: "0.09 - 0.12" },
      },

      {
        friction_material_1: { value: "Glass" },
        friction_material_2: { value: "Metal" },
        conditions: { value: "Clean and Dry" },
        friction_coefficient_static: { value: "0.5 - 0.7" },
        friction_coefficient_dynamic: { value: "" },
      },

      {
        friction_material_1: { value: "Glass" },
        friction_material_2: { value: "Metal" },
        conditions: { value: "Lubricated and Greasy" },
        friction_coefficient_static: { value: "0.2 - 0.3" },
        friction_coefficient_dynamic: { value: "" },
      },

      {
        friction_material_1: { value: "Glass" },
        friction_material_2: { value: "Nickel" },
        conditions: { value: "Clean and Dry" },
        friction_coefficient_static: { value: "0.78" },
        friction_coefficient_dynamic: { value: "" },
      },

      {
        friction_material_1: { value: "Glass" },
        friction_material_2: { value: "Nickel" },
        conditions: { value: "Lubricated and Greasy" },
        friction_coefficient_static: { value: "0.56" },
        friction_coefficient_dynamic: { value: "" },
      },

      {
        friction_material_1: { value: "Graphite" },
        friction_material_2: { value: "Steel" },
        conditions: { value: "Clean and Dry" },
        friction_coefficient_static: { value: "0.1" },
        friction_coefficient_dynamic: { value: "" },
      },

      {
        friction_material_1: { value: "Graphite" },
        friction_material_2: { value: "Steel" },
        conditions: { value: "Lubricated and Greasy" },
        friction_coefficient_static: { value: "0.1" },
        friction_coefficient_dynamic: { value: "" },
      },

      {
        friction_material_1: { value: "Graphite" },
        friction_material_2: { value: "Graphite (in vacuum)" },
        conditions: { value: "Clean and Dry" },
        friction_coefficient_static: { value: "0.5 - 0.8 " },
        friction_coefficient_dynamic: { value: "" },
      },

      {
        friction_material_1: { value: "Graphite" },
        friction_material_2: { value: "Graphite" },
        conditions: { value: "Clean and Dry" },
        friction_coefficient_static: { value: "0.1" },
        friction_coefficient_dynamic: { value: "" },
      },

      {
        friction_material_1: { value: "Graphite" },
        friction_material_2: { value: "Graphite" },
        conditions: { value: "Lubricated and Greasy" },
        friction_coefficient_static: { value: "0.1" },
        friction_coefficient_dynamic: { value: "" },
      },

      {
        friction_material_1: { value: "Hemp rope" },
        friction_material_2: { value: "Timber" },
        conditions: { value: "Clean and Dry" },
        friction_coefficient_static: { value: "0.5" },
        friction_coefficient_dynamic: { value: "" },
      },

      {
        friction_material_1: { value: "Horseshoe" },
        friction_material_2: { value: "Rubber" },
        conditions: { value: "Clean and Dry" },
        friction_coefficient_static: { value: "0.68 " },
        friction_coefficient_dynamic: { value: "" },
      },

      {
        friction_material_1: { value: "Horseshoe" },
        friction_material_2: { value: "Concrete" },
        conditions: { value: "Clean and Dry" },
        friction_coefficient_static: { value: "0.58" },
        friction_coefficient_dynamic: { value: "" },
      },

      {
        friction_material_1: { value: "Ice" },
        friction_material_2: { value: "Ice" },
        conditions: { value: "Clean 0\u00B0C" },
        friction_coefficient_static: { value: "0.1" },
        friction_coefficient_dynamic: { value: "0.02" },
      },

      {
        friction_material_1: { value: "Ice" },
        friction_material_2: { value: "Ice" },
        conditions: { value: "Clean -12\u00B0C" },
        friction_coefficient_static: { value: "0.3" },
        friction_coefficient_dynamic: { value: "0.035" },
      },

      {
        friction_material_1: { value: "Ice" },
        friction_material_2: { value: "Ice" },
        conditions: { value: "Clean -80\u00B0C" },
        friction_coefficient_static: { value: "0.5" },
        friction_coefficient_dynamic: { value: "0.09" },
      },

      {
        friction_material_1: { value: "Ice" },
        friction_material_2: { value: "Wood" },
        conditions: { value: "Clean and Dry" },
        friction_coefficient_static: { value: "0.05" },
        friction_coefficient_dynamic: { value: "" },
      },

      {
        friction_material_1: { value: "Ice" },
        friction_material_2: { value: "Steel" },
        conditions: { value: "Clean and Dry" },
        friction_coefficient_static: { value: "0.03" },
        friction_coefficient_dynamic: { value: "" },
      },

      {
        friction_material_1: { value: "Iron" },
        friction_material_2: { value: "Iron" },
        conditions: { value: "Clean and Dry" },
        friction_coefficient_static: { value: "1.0" },
        friction_coefficient_dynamic: { value: "" },
      },

      {
        friction_material_1: { value: "Iron" },
        friction_material_2: { value: "Iron" },
        conditions: { value: "Lubricated and Greasy" },
        friction_coefficient_static: { value: "0.15 - 0.20" },
        friction_coefficient_dynamic: { value: "" },
      },

      {
        friction_material_1: { value: "Lead" },
        friction_material_2: { value: "Cast Iron" },
        conditions: { value: "Clean and Dry" },
        friction_coefficient_static: { value: "" },
        friction_coefficient_dynamic: { value: "0.43" },
      },

      {
        friction_material_1: { value: "Leather" },
        friction_material_2: { value: "Oak" },
        conditions: { value: "Parallel to grain" },
        friction_coefficient_static: { value: "0.61" },
        friction_coefficient_dynamic: { value: "0.52" },
      },

      {
        friction_material_1: { value: "Leather" },
        friction_material_2: { value: "Metal" },
        conditions: { value: "Clean and Dry" },
        friction_coefficient_static: { value: "0.4" },
        friction_coefficient_dynamic: { value: "" },
      },

      {
        friction_material_1: { value: "Leather" },
        friction_material_2: { value: "Metal" },
        conditions: { value: "Lubricated and Greasy" },
        friction_coefficient_static: { value: "0.2" },
        friction_coefficient_dynamic: { value: "" },
      },

      {
        friction_material_1: { value: "Leather" },
        friction_material_2: { value: "Wood" },
        conditions: { value: "Clean and Dry" },
        friction_coefficient_static: { value: "0.3 - 0.4" },
        friction_coefficient_dynamic: { value: "" },
      },

      {
        friction_material_1: { value: "Leather" },
        friction_material_2: { value: "Clean Metal" },
        conditions: { value: "Clean and Dry" },
        friction_coefficient_static: { value: "0.6" },
        friction_coefficient_dynamic: { value: "" },
      },

      {
        friction_material_1: { value: "Leather" },
        friction_material_2: { value: "Cast Iron" },
        conditions: { value: "Clean and Dry" },
        friction_coefficient_static: { value: "0.6" },
        friction_coefficient_dynamic: { value: "0.56" },
      },

      {
        friction_material_1: { value: "Leather fiber" },
        friction_material_2: { value: "Cast iron" },
        conditions: { value: "Clean and Dry" },
        friction_coefficient_static: { value: "0.31" },
        friction_coefficient_dynamic: { value: "" },
      },

      {
        friction_material_1: { value: "Leather fiber" },
        friction_material_2: { value: "Aluminum" },
        conditions: { value: "Clean and Dry" },
        friction_coefficient_static: { value: "0.30" },
        friction_coefficient_dynamic: { value: "" },
      },

      {
        friction_material_1: { value: "Magnesium" },
        friction_material_2: { value: "Magnesium" },
        conditions: { value: "Clean and Dry" },
        friction_coefficient_static: { value: "0.6" },
        friction_coefficient_dynamic: { value: "" },
      },

      {
        friction_material_1: { value: "Magnesium" },
        friction_material_2: { value: "Magnesium" },
        conditions: { value: "Lubricated and Greasy" },
        friction_coefficient_static: { value: "0.08" },
        friction_coefficient_dynamic: { value: "" },
      },

      {
        friction_material_1: { value: "Magnesium" },
        friction_material_2: { value: "Steel" },
        conditions: { value: "lean and Dry" },
        friction_coefficient_static: { value: "" },
        friction_coefficient_dynamic: { value: "0.42" },
      },

      {
        friction_material_1: { value: "Magnesium" },
        friction_material_2: { value: "Cast Iron" },
        conditions: { value: "Clean and Dry" },
        friction_coefficient_static: { value: "" },
        friction_coefficient_dynamic: { value: "0.25" },
      },

      {
        friction_material_1: { value: "Masonry" },
        friction_material_2: { value: "Brick" },
        conditions: { value: "Clean and Dry" },
        friction_coefficient_static: { value: "0.6 - 0.7" },
        friction_coefficient_dynamic: { value: "" },
      },

      {
        friction_material_1: { value: "Mica" },
        friction_material_2: { value: "Mica" },
        conditions: { value: "Freshly cleaved" },
        friction_coefficient_static: { value: "1.0" },
        friction_coefficient_dynamic: { value: "" },
      },

      {
        friction_material_1: { value: "Nickel" },
        friction_material_2: { value: "Nickel" },
        conditions: { value: "Clean and Dry" },
        friction_coefficient_static: { value: "0.7 - 1.1" },
        friction_coefficient_dynamic: { value: "0.53" },
      },

      {
        friction_material_1: { value: "Nickel" },
        friction_material_2: { value: "Nickel" },
        conditions: { value: "Lubricated and Greasy" },
        friction_coefficient_static: { value: "0.28" },
        friction_coefficient_dynamic: { value: "0.12" },
      },

      {
        friction_material_1: { value: "Nickel" },
        friction_material_2: { value: "Mild Steel" },
        conditions: { value: "Clean and Dry" },
        friction_coefficient_static: { value: "" },
        friction_coefficient_dynamic: { value: "0.64" },
      },

      {
        friction_material_1: { value: "Nickel" },
        friction_material_2: { value: "Mild Steel" },
        conditions: { value: "Lubricated and Greasy" },
        friction_coefficient_static: { value: "" },
        friction_coefficient_dynamic: { value: "0.178" },
      },

      {
        friction_material_1: { value: "Nylon" },
        friction_material_2: { value: "Nylon" },
        conditions: { value: "Clean and Dry" },
        friction_coefficient_static: { value: "0.15 - 0.25" },
        friction_coefficient_dynamic: { value: "" },
      },

      {
        friction_material_1: { value: "Nylon" },
        friction_material_2: { value: "Steel" },
        conditions: { value: "Clean and Dry" },
        friction_coefficient_static: { value: "0.4" },
        friction_coefficient_dynamic: { value: "" },
      },

      {
        friction_material_1: { value: "Nylon" },
        friction_material_2: { value: "Snow" },
        conditions: { value: "Wet 0\u00B0C" },
        friction_coefficient_static: { value: "0.4" },
        friction_coefficient_dynamic: { value: "" },
      },

      {
        friction_material_1: { value: "Nylon" },
        friction_material_2: { value: "Snow" },
        conditions: { value: "Dry -10oC" },
        friction_coefficient_static: { value: "0.3" },
        friction_coefficient_dynamic: { value: "" },
      },

      {
        friction_material_1: { value: "Oak" },
        friction_material_2: { value: "Oak (parallel grain)" },
        conditions: { value: "Clean and Dry" },
        friction_coefficient_static: { value: "0.62" },
        friction_coefficient_dynamic: { value: "0.48" },
      },

      {
        friction_material_1: { value: "Oak" },
        friction_material_2: { value: "Oak (cross grain)" },
        conditions: { value: "Clean and Dry" },
        friction_coefficient_static: { value: "0.54" },
        friction_coefficient_dynamic: { value: "0.32" },
      },

      {
        friction_material_1: { value: "Oak" },
        friction_material_2: { value: "Oak (cross grain)" },
        conditions: { value: "Lubricated and Greasy" },
        friction_coefficient_static: { value: "" },
        friction_coefficient_dynamic: { value: "0.072" },
      },

      {
        friction_material_1: { value: "Paper" },
        friction_material_2: { value: "Cast Iron" },
        conditions: { value: "Clean and Dry" },
        friction_coefficient_static: { value: "0.20" },
        friction_coefficient_dynamic: { value: "" },
      },

      {
        friction_material_1: { value: "Phosphor-bronze" },
        friction_material_2: { value: "Steel" },
        conditions: { value: "Clean and Dry" },
        friction_coefficient_static: { value: "0.35" },
        friction_coefficient_dynamic: { value: "" },
      },

      {
        friction_material_1: { value: "Platinum" },
        friction_material_2: { value: "Platinum" },
        conditions: { value: "Clean and Dry" },
        friction_coefficient_static: { value: "1.2" },
        friction_coefficient_dynamic: { value: "" },
      },

      {
        friction_material_1: { value: "Platinum" },
        friction_material_2: { value: "Platinum" },
        conditions: { value: "Lubricated and Greasy" },
        friction_coefficient_static: { value: "0.25" },
        friction_coefficient_dynamic: { value: "" },
      },

      {
        friction_material_1: { value: "Plexiglas" },
        friction_material_2: { value: "Plexiglas" },
        conditions: { value: "Clean and Dry" },
        friction_coefficient_static: { value: "0.8" },
        friction_coefficient_dynamic: { value: "" },
      },

      {
        friction_material_1: { value: "Plexiglas" },
        friction_material_2: { value: "Plexiglas" },
        conditions: { value: "Lubricated and Greasy" },
        friction_coefficient_static: { value: "0.8" },
        friction_coefficient_dynamic: { value: "" },
      },

      {
        friction_material_1: { value: "Plexiglas" },
        friction_material_2: { value: "Steel" },
        conditions: { value: "Clean and Dry" },
        friction_coefficient_static: { value: "0.4 - 0.5" },
        friction_coefficient_dynamic: { value: "" },
      },

      {
        friction_material_1: { value: "Plexiglas" },
        friction_material_2: { value: "Steel" },
        conditions: { value: "Lubricated and Greasy" },
        friction_coefficient_static: { value: "0.4 - 0.5" },
        friction_coefficient_dynamic: { value: "" },
      },

      {
        friction_material_1: { value: "Polystyrene" },
        friction_material_2: { value: "Polystyrene" },
        conditions: { value: "Clean and Dry" },
        friction_coefficient_static: { value: "0.5" },
        friction_coefficient_dynamic: { value: "" },
      },

      {
        friction_material_1: { value: "Polystyrene" },
        friction_material_2: { value: "Polystyrene" },
        conditions: { value: "Lubricated and Greasy" },
        friction_coefficient_static: { value: "0.5" },
        friction_coefficient_dynamic: { value: "" },
      },

      {
        friction_material_1: { value: "Polystyrene" },
        friction_material_2: { value: "Steel" },
        conditions: { value: "Clean and Dry" },
        friction_coefficient_static: { value: "0.3 - 0.35" },
        friction_coefficient_dynamic: { value: "" },
      },

      {
        friction_material_1: { value: "Polystyrene" },
        friction_material_2: { value: "Steel" },
        conditions: { value: "Lubricated and Greasy" },
        friction_coefficient_static: { value: "0.3 - 0.35" },
        friction_coefficient_dynamic: { value: "" },
      },

      {
        friction_material_1: { value: "Polyethylene" },
        friction_material_2: { value: "Polytehylene" },
        conditions: { value: "Clean and Dry" },
        friction_coefficient_static: { value: "0.2" },
        friction_coefficient_dynamic: { value: "" },
      },

      {
        friction_material_1: { value: "Polyethylene" },
        friction_material_2: { value: "Steel" },
        conditions: { value: "Clean and Dry" },
        friction_coefficient_static: { value: "0.2" },
        friction_coefficient_dynamic: { value: "" },
      },

      {
        friction_material_1: { value: "Polyethylene" },
        friction_material_2: { value: "Steel" },
        conditions: { value: "Lubricated and Greasy" },
        friction_coefficient_static: { value: "0.2" },
        friction_coefficient_dynamic: { value: "" },
      },

      {
        friction_material_1: { value: "Rubber" },
        friction_material_2: { value: "Rubber" },
        conditions: { value: "Clean and Dry" },
        friction_coefficient_static: { value: "1.16" },
        friction_coefficient_dynamic: { value: "" },
      },

      {
        friction_material_1: { value: "Rubber" },
        friction_material_2: { value: "Cardboard" },
        conditions: { value: "Clean and Dry" },
        friction_coefficient_static: { value: "0.5 - 0.8" },
        friction_coefficient_dynamic: { value: "" },
      },

      {
        friction_material_1: { value: "Rubber" },
        friction_material_2: { value: "Dry Asphalt" },
        conditions: { value: "Clean and Dry" },
        friction_coefficient_static: { value: "0.9" },
        friction_coefficient_dynamic: { value: "0.5 - 0.8" },
      },

      {
        friction_material_1: { value: "Rubber" },
        friction_material_2: { value: "Wet Asphalt" },
        conditions: { value: "Clean and Dry" },
        friction_coefficient_static: { value: "" },
        friction_coefficient_dynamic: { value: "0.25 - 0.75" },
      },

      {
        friction_material_1: { value: "Rubber" },
        friction_material_2: { value: "Dry Concrete" },
        conditions: { value: "Clean and Dry" },
        friction_coefficient_static: { value: "" },
        friction_coefficient_dynamic: { value: "0.6 - 0.85" },
      },

      {
        friction_material_1: { value: "Rubber" },
        friction_material_2: { value: "Wet Concrete" },
        conditions: { value: "Clean and Dry" },
        friction_coefficient_static: { value: "" },
        friction_coefficient_dynamic: { value: "0.45 - 0.75" },
      },

      {
        friction_material_1: { value: "Silk" },
        friction_material_2: { value: "Silk" },
        conditions: { value: "Clean" },
        friction_coefficient_static: { value: "0.25" },
        friction_coefficient_dynamic: { value: "" },
      },

      {
        friction_material_1: { value: "Silver" },
        friction_material_2: { value: "Silver" },
        conditions: { value: "Clean and Dry" },
        friction_coefficient_static: { value: "1.4" },
        friction_coefficient_dynamic: { value: "" },
      },

      {
        friction_material_1: { value: "Silver" },
        friction_material_2: { value: "Silver" },
        conditions: { value: "Lubricated and Greasy" },
        friction_coefficient_static: { value: "0.55" },
        friction_coefficient_dynamic: { value: "" },
      },

      {
        friction_material_1: { value: "Sapphire" },
        friction_material_2: { value: "Sapphire" },
        conditions: { value: "Clean and Dry" },
        friction_coefficient_static: { value: "0.2" },
        friction_coefficient_dynamic: { value: "" },
      },

      {
        friction_material_1: { value: "Sapphire" },
        friction_material_2: { value: "Sapphire" },
        conditions: { value: "Lubricated and Greasy" },
        friction_coefficient_static: { value: "0.2" },
        friction_coefficient_dynamic: { value: "" },
      },

      {
        friction_material_1: { value: "Silver" },
        friction_material_2: { value: "Silver" },
        conditions: { value: "Clean and Dry" },
        friction_coefficient_static: { value: "1.4" },
        friction_coefficient_dynamic: { value: "" },
      },

      {
        friction_material_1: { value: "Silver" },
        friction_material_2: { value: "Silver" },
        conditions: { value: "Lubricated and Greasy" },
        friction_coefficient_static: { value: "0.55" },
        friction_coefficient_dynamic: { value: "" },
      },

      {
        friction_material_1: { value: "Skin" },
        friction_material_2: { value: "Metals" },
        conditions: { value: "Clean and Dry" },
        friction_coefficient_static: { value: "0.8 - 1.0" },
        friction_coefficient_dynamic: { value: "" },
      },

      {
        friction_material_1: { value: "Steel" },
        friction_material_2: { value: "Steel" },
        conditions: { value: "Clean and Dry" },
        friction_coefficient_static: { value: "0.5 - 0.8" },
        friction_coefficient_dynamic: { value: "0.42" },
      },

      {
        friction_material_1: { value: "Steel" },
        friction_material_2: { value: "Steel" },
        conditions: { value: "Lubricated and Greasy" },
        friction_coefficient_static: { value: "0.16" },
        friction_coefficient_dynamic: { value: "" },
      },

      {
        friction_material_1: { value: "Steel" },
        friction_material_2: { value: "Steel" },
        conditions: { value: "Castor oil" },
        friction_coefficient_static: { value: "0.15" },
        friction_coefficient_dynamic: { value: "0.081" },
      },

      {
        friction_material_1: { value: "Steel" },
        friction_material_2: { value: "Steel" },
        conditions: { value: "Stearic Acid" },
        friction_coefficient_static: { value: "" },
        friction_coefficient_dynamic: { value: "0.15" },
      },

      {
        friction_material_1: { value: "Steel" },
        friction_material_2: { value: "Steel" },
        conditions: { value: "Light mineral oil" },
        friction_coefficient_static: { value: "0.23" },
        friction_coefficient_dynamic: { value: "" },
      },

      {
        friction_material_1: { value: "Steel" },
        friction_material_2: { value: "Steel" },
        conditions: { value: "Lard" },
        friction_coefficient_static: { value: "0.11" },
        friction_coefficient_dynamic: { value: "0.084" },
      },

      {
        friction_material_1: { value: "Steel" },
        friction_material_2: { value: "Steel" },
        conditions: { value: "Graphite" },
        friction_coefficient_static: { value: "" },
        friction_coefficient_dynamic: { value: "0.058" },
      },

      {
        friction_material_1: { value: "Steel" },
        friction_material_2: { value: "Graphite" },
        conditions: { value: "Clean and Dry" },
        friction_coefficient_static: { value: "0.21" },
        friction_coefficient_dynamic: { value: "" },
      },

      {
        friction_material_1: { value: "Straw Fiber" },
        friction_material_2: { value: "Cast Iron" },
        conditions: { value: "Clean and Dry" },
        friction_coefficient_static: { value: "0.26" },
        friction_coefficient_dynamic: { value: "" },
      },

      {
        friction_material_1: { value: "Straw Fiber" },
        friction_material_2: { value: "Aluminum" },
        conditions: { value: "Clean and Dry" },
        friction_coefficient_static: { value: "0.27" },
        friction_coefficient_dynamic: { value: "" },
      },

      {
        friction_material_1: { value: "Tarred fiber" },
        friction_material_2: { value: "Cast Iron" },
        conditions: { value: "Clean and Dry" },
        friction_coefficient_static: { value: "0.15" },
        friction_coefficient_dynamic: { value: "" },
      },

      {
        friction_material_1: { value: "Tarred fiber" },
        friction_material_2: { value: "Aluminum" },
        conditions: { value: "Clean and Dry" },
        friction_coefficient_static: { value: "0.18" },
        friction_coefficient_dynamic: { value: "" },
      },

      {
        friction_material_1: {
          value: "Polytetrafluoroethylene (PTFE) (Teflon)",
        },
        friction_material_2: { value: "Polytetrafluoroethylene (PTFE)" },
        conditions: { value: "Clean and Dry" },
        friction_coefficient_static: { value: "0.04" },
        friction_coefficient_dynamic: { value: "0.04" },
      },

      {
        friction_material_1: { value: "Polytetrafluoroethylene (PTFE)" },
        friction_material_2: { value: "Polytetrafluoroethylene (PTFE)" },
        conditions: { value: "Lubricated and Greasy" },
        friction_coefficient_static: { value: "0.04" },
        friction_coefficient_dynamic: { value: "" },
      },

      {
        friction_material_1: { value: "Polytetrafluoroethylene (PTFE)" },
        friction_material_2: { value: "Steel" },
        conditions: { value: "Clean and Dry" },
        friction_coefficient_static: { value: "0.05 - 0.2" },
        friction_coefficient_dynamic: { value: "" },
      },

      {
        friction_material_1: { value: "Polytetrafluoroethylene (PTFE)" },
        friction_material_2: { value: "Snow" },
        conditions: { value: "Wet 0oC" },
        friction_coefficient_static: { value: "0.05" },
        friction_coefficient_dynamic: { value: "" },
      },

      {
        friction_material_1: { value: "Polytetrafluoroethylene (PTFE)" },
        friction_material_2: { value: "Snow" },
        conditions: { value: "Dry 0oC" },
        friction_coefficient_static: { value: "0.02" },
        friction_coefficient_dynamic: { value: "" },
      },

      {
        friction_material_1: { value: "Tungsten Carbide" },
        friction_material_2: { value: "Steel" },
        conditions: { value: "Clean and Dry" },
        friction_coefficient_static: { value: "0.4 - 0.6" },
        friction_coefficient_dynamic: { value: "" },
      },

      {
        friction_material_1: { value: "Tungsten Carbide" },
        friction_material_2: { value: "Steel" },
        conditions: { value: "Lubricated and Greasy" },
        friction_coefficient_static: { value: "0.1 - 0.2" },
        friction_coefficient_dynamic: { value: "" },
      },

      {
        friction_material_1: { value: "Tungsten Carbide" },
        friction_material_2: { value: "Tungsten Carbide" },
        conditions: { value: "Clean and Dry" },
        friction_coefficient_static: { value: "0.2 - 0.25" },
        friction_coefficient_dynamic: { value: "" },
      },

      {
        friction_material_1: { value: "Tungsten Carbide" },
        friction_material_2: { value: "Tungsten Carbide" },
        conditions: { value: "Lubricated and Greasy" },
        friction_coefficient_static: { value: "0.12" },
        friction_coefficient_dynamic: { value: "" },
      },

      {
        friction_material_1: { value: "Tungsten Carbide" },
        friction_material_2: { value: "Copper" },
        conditions: { value: "Clean and Dry" },
        friction_coefficient_static: { value: "0.35" },
        friction_coefficient_dynamic: { value: "" },
      },

      {
        friction_material_1: { value: "Tungsten Carbide" },
        friction_material_2: { value: "Iron" },
        conditions: { value: "Clean and Dry" },
        friction_coefficient_static: { value: ".8" },
        friction_coefficient_dynamic: { value: "" },
      },

      {
        friction_material_1: { value: "Tin" },
        friction_material_2: { value: "Cast Iron" },
        conditions: { value: "Clean and Dry" },
        friction_coefficient_static: { value: "" },
        friction_coefficient_dynamic: { value: "0.32" },
      },

      {
        friction_material_1: { value: "Tire, dry" },
        friction_material_2: { value: "Road, dry" },
        conditions: { value: "Clean and Dry" },
        friction_coefficient_static: { value: "1" },
        friction_coefficient_dynamic: { value: "" },
      },

      {
        friction_material_1: { value: "Tire, wet" },
        friction_material_2: { value: "Road, wet" },
        conditions: { value: "Clean and Dry" },
        friction_coefficient_static: { value: "0.2" },
        friction_coefficient_dynamic: { value: "" },
      },

      {
        friction_material_1: { value: "Wax, ski" },
        friction_material_2: { value: "Snow" },
        conditions: { value: "Wet 0oC" },
        friction_coefficient_static: { value: "0.1" },
        friction_coefficient_dynamic: { value: "" },
      },

      {
        friction_material_1: { value: "Wax, ski" },
        friction_material_2: { value: "Snow" },
        conditions: { value: "Dry 0oC" },
        friction_coefficient_static: { value: "0.04" },
        friction_coefficient_dynamic: { value: "" },
      },

      {
        friction_material_1: { value: "Wax, ski" },
        friction_material_2: { value: "Snow" },
        conditions: { value: "Dry -10oC" },
        friction_coefficient_static: { value: "0.2" },
        friction_coefficient_dynamic: { value: "" },
      },

      {
        friction_material_1: { value: "Wood" },
        friction_material_2: { value: "Clean Wood" },
        conditions: { value: "Clean and Dry" },
        friction_coefficient_static: { value: "0.25 - 0.5" },
        friction_coefficient_dynamic: { value: "" },
      },

      {
        friction_material_1: { value: "Wood" },
        friction_material_2: { value: "Wet Wood" },
        conditions: { value: "Clean and Dry" },
        friction_coefficient_static: { value: "0.2" },
        friction_coefficient_dynamic: { value: "" },
      },

      {
        friction_material_1: { value: "Wood" },
        friction_material_2: { value: "Clean Metal" },
        conditions: { value: "Clean and Dry" },
        friction_coefficient_static: { value: "0.2 - 0.6" },
        friction_coefficient_dynamic: { value: "" },
      },

      {
        friction_material_1: { value: "Wood" },
        friction_material_2: { value: "Wet Metals" },
        conditions: { value: "Clean and Dry" },
        friction_coefficient_static: { value: "0.2" },
        friction_coefficient_dynamic: { value: "" },
      },

      {
        friction_material_1: { value: "Wood" },
        friction_material_2: { value: "Stone" },
        conditions: { value: "Clean and Dry" },
        friction_coefficient_static: { value: "0.2 - 0.4" },
        friction_coefficient_dynamic: { value: "" },
      },

      {
        friction_material_1: { value: "Wood" },
        friction_material_2: { value: "Concrete" },
        conditions: { value: "Clean and Dry" },
        friction_coefficient_static: { value: "0.62" },
        friction_coefficient_dynamic: { value: "" },
      },

      {
        friction_material_1: { value: "Wood" },
        friction_material_2: { value: "Brick" },
        conditions: { value: "Clean and Dry" },
        friction_coefficient_static: { value: "0.6" },
        friction_coefficient_dynamic: { value: "" },
      },

      {
        friction_material_1: { value: "Wood - waxed" },
        friction_material_2: { value: "Wet snow" },
        conditions: { value: "Clean and Dry" },
        friction_coefficient_static: { value: "0.14" },
        friction_coefficient_dynamic: { value: "0.1" },
      },

      {
        friction_material_1: { value: "Wood - waxed" },
        friction_material_2: { value: "Dry snow" },
        conditions: { value: "Clean and Dry " },
        friction_coefficient_static: { value: "" },
        friction_coefficient_dynamic: { value: "0.04" },
      },

      {
        friction_material_1: { value: "Zinc" },
        friction_material_2: { value: "Cast Iron" },
        conditions: { value: "Clean and Dry" },
        friction_coefficient_static: { value: "0.85" },
        friction_coefficient_dynamic: { value: "0.21" },
      },

      {
        friction_material_1: { value: "Zinc" },
        friction_material_2: { value: "Zinc" },
        conditions: { value: "Clean and Dry" },
        friction_coefficient_static: { value: "0.6" },
        friction_coefficient_dynamic: { value: "" },
      },

      {
        friction_material_1: { value: "Zinc" },
        friction_material_2: { value: "Zinc" },
        conditions: { value: "Lubricated and Greasy" },
        friction_coefficient_static: { value: "0.04" },
        friction_coefficient_dynamic: { value: "" },
      },
    ],
  },
];
